import { render, staticRenderFns } from "./TomsList.vue?vue&type=template&id=195691b5&scoped=true"
import script from "./TomsList.vue?vue&type=script&lang=js"
export * from "./TomsList.vue?vue&type=script&lang=js"
import style0 from "./TomsList.vue?vue&type=style&index=0&id=195691b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195691b5",
  null
  
)

export default component.exports